import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineSection, UpdateTimelineSectionPayload } from 'views/Tasks/Timeline/types';

export const updateTimelineSection = async (
    {
        orgId, dealId, sectionId, patchData,
    }: { orgId: string; dealId: number; sectionId: number; patchData: UpdateTimelineSectionPayload },
): Promise<TimelineSection> => {
    const response = await axiosInstance.patch<TimelineSection>(API_ENDPOINTS.TIMELINE_SECTION_BY_ID(orgId, dealId, sectionId), patchData);
    return response.data;
};

export const useUpdateTimelineSection = () => useMutation({
    mutationFn: updateTimelineSection,
});
